import API from "../api";

/** Fetch the current student's wallet balance and transaction history. */
export const getMyWallet = () => API.get("/student/wallet").then((r) => r.data);

/** List enabled online gateways for students (GATEWAY kind, visible_to_students). */
export const getStudentOnlineGateways = () =>
  API.get("/public/payment-methods").then((r) => {
    const rows = Array.isArray(r.data) ? r.data : [];
    return rows.filter((m) => m.methodKind === "GATEWAY");
  });

/**
 * Creates a payment session on the backend.
 * @param {number} amount
 * @param {string} gateway - GATEWAY_RAZORPAY | GATEWAY_STRIPE | GATEWAY_PAYPAL
 */
export const initiateOnlineTopup = (amount, gateway, options = {}) =>
  API.post("/student/wallet/topup/initiate", {
    amount,
    gateway,
    purpose: options.purpose,
    enrollmentId: options.enrollmentId,
  }).then((r) => r.data);

/** Verifies a Razorpay payment signature and credits the wallet. */
export const verifyRazorpayPayment = (payload) =>
  API.post("/student/wallet/topup/verify", {
    gateway: "GATEWAY_RAZORPAY",
    ...payload,
  }).then((r) => r.data);

/** Confirms Stripe or PayPal payment after redirect. */
export const completeOnlineTopup = (gateway, externalId) =>
  API.post("/student/wallet/topup/complete", { gateway, externalId }).then((r) => r.data);

export const getTopupStatus = (gateway, externalId) =>
  API.get("/student/wallet/topup/status", { params: { gateway, externalId } }).then((r) => r.data);

/** @deprecated Use initiateOnlineTopup */
export const initiateRazorpayTopup = (amount) =>
  initiateOnlineTopup(amount, "GATEWAY_RAZORPAY");

export const getAutopayStatus = () =>
  API.get("/student/wallet/autopay").then((r) => r.data);

export const startAutopaySetup = () =>
  API.post("/student/wallet/autopay/setup").then((r) => r.data);

export const completeAutopaySetup = (sessionId, paymentId) =>
  API.post("/student/wallet/autopay/complete", {
    sessionId,
    orderId: sessionId,
    paymentId,
  }).then((r) => r.data);

export const revokeAutopay = () =>
  API.delete("/student/wallet/autopay").then((r) => r.data);

export const downloadWalletReceipt = async (txnId) => {
  const response = await API.get(`/student/wallet/receipt/${txnId}`, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(
    new Blob([response.data], { type: "application/pdf" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `receipt-TXN-${txnId}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
